/* ============================================================
   SeekJoy — editorial page transition (DrawSVG cover/reveal)
   Real page loads (NOT a Barba SPA): intercept internal link
   clicks, draw the shape across to cover, navigate, then draw
   it away to reveal. Fails safe — if GSAP/DrawSVG don't load,
   links behave normally.
   ============================================================ */
(function () {
  if (typeof window.gsap === 'undefined' || typeof window.DrawSVGPlugin === 'undefined') return;
  gsap.registerPlugin(DrawSVGPlugin);

  var root = document.documentElement;
  var wrap = document.querySelector('[data-transition]');
  if (!wrap) return;
  var path = wrap.querySelector('svg path');
  if (!path) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var COVER_DUR = 0.8;
  var REVEAL_DUR = 0.95;

  // ENTER — arrived via a transition: draw the cover away to reveal the page
  function reveal() {
    if (!root.classList.contains('sj-transitioning')) return;
    if (reduce) { root.classList.remove('sj-transitioning'); return; }
    gsap.set(path, { drawSVG: '0% 100%', strokeWidth: '30%' });
    gsap.timeline({ onComplete: function () { root.classList.remove('sj-transitioning'); } })
      .to(path, { duration: REVEAL_DUR, drawSVG: '100% 100%', strokeWidth: '5%', ease: 'power1.inOut' });
  }
  try { sessionStorage.removeItem('sj-transit'); } catch (e) {}
  reveal();

  // LEAVE — cover the screen, then navigate
  var navigating = false;
  function cover(href) {
    if (navigating) return;
    navigating = true;
    try { sessionStorage.setItem('sj-transit', '1'); } catch (e) {}
    root.classList.add('sj-transitioning');
    gsap.set(path, { strokeWidth: '5%', drawSVG: '0% 0%' });
    var go = function () { window.location.href = href; };
    var tl = gsap.timeline({ onComplete: go });
    tl.to(path, { duration: COVER_DUR, drawSVG: '0% 85%', ease: 'power1.inOut' });
    tl.to(path, { duration: COVER_DUR * 0.75, strokeWidth: '30%', ease: 'power1.inOut' }, '<0.2');
    // Safety: navigate even if the timeline is paused (e.g. backgrounded tab)
    setTimeout(go, 1500);
  }

  document.addEventListener('click', function (e) {
    if (reduce || e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a');
    if (!a) return;
    if (a.target === '_blank' || a.hasAttribute('download') || a.getAttribute('rel') === 'external') return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return;
    var url;
    try { url = new URL(href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;                 // external -> normal
    if (url.pathname === window.location.pathname && url.search === window.location.search) return; // same page
    e.preventDefault();
    cover(url.href);
  });

  // Back/forward cache: clear any stuck overlay on restore
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { root.classList.remove('sj-transitioning'); gsap.set(path, { clearProps: 'all' }); navigating = false; }
  });
})();

/* ============================================================
   Cross-browser hover/focus prefetch. Speculation Rules covers
   Chrome/Edge; this warms the destination on Firefox/Safari too
   (rel=prefetch on intent) so the next page first-paints fast and
   the inter-document blank never shows. Independent of GSAP — runs
   even if the transition fails to load. Skips cart/checkout/account.
   ============================================================ */
(function () {
  var seen = {};
  function target(a) {
    if (!a) return null;
    if (a.target === '_blank' || a.hasAttribute('download') || a.getAttribute('rel') === 'external') return null;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return null;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0 || href.indexOf('javascript:') === 0) return null;
    var url;
    try { url = new URL(href, window.location.href); } catch (_) { return null; }
    if (url.origin !== window.location.origin) return null;
    if (/^\/(cart|checkout|account)(\/|$)/.test(url.pathname)) return null;
    if (url.pathname === window.location.pathname && url.search === window.location.search) return null;
    if (seen[url.href]) return null;
    return url.href;
  }
  function warm(e) {
    var el = e.target;
    var a = el && el.closest ? el.closest('a') : null;
    var href = target(a);
    if (!href) return;
    seen[href] = 1;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    document.head.appendChild(link);
  }
  document.addEventListener('pointerover', warm, { capture: true, passive: true });
  document.addEventListener('touchstart', warm, { capture: true, passive: true });
  document.addEventListener('focusin', warm, true);
})();
